export const AGENDA_POPOVER_ACTIONS = Object.freeze({
  CONFIRM: 'confirm',
  CANCEL: 'cancel',
  CANCEL_VISITOR: 'cancelVisitor',
  CANCEL_GROUP: 'cancelGroup',
  RESCHEDULE: 'reschedule',
  MORE_ACTIONS: 'moreActions',
});

export const AGENDA_SATELLITE_TRACKING_EVENTS = Object.freeze({
  DATETIME_WITH_WARNING_SELECTED: 'new_visit_datetime_with_warning_selected',
});

export const AGENDA_SATELLITE_TEXT = Object.freeze({
  POPOVER_ARIA_LABEL: 'Abrir ações da visita',
  CONFIRM_VISIT: 'Confirmar visita',
  CANCEL_VISIT: 'Cancelar visita',
  CANCEL_VISITOR: 'Cancelar visitante',
  RESCHEDULE_VISIT: 'Reagendar visita',
  MORE_ACTIONS: 'Mais ações',
  UNREAD_MESSAGE: 'Você tem novas mensagens',
  UNREAD_ACTION: 'Ver',
  ERROR_TITLE: 'Ocorreu algo inesperado',
  ERROR_DESCRIPTION:
    'Atualize a página para carregar as informações novamente.',
  ERROR_BUTTON: 'Atualizar página',
  ACTIVITY_TITLE: 'Nova tela de atividades',
  ACTIVITY_DESCRIPTION: 'Confira o seu relatório de atividades desse mês.',
  QUALIFIED_VISITOR: 'Cliente tem proposta aceita pelo proprietário.',
  DATE_PICKER_LABEL: 'Selecione a data',
  TIME_PICKER_LABEL: 'Selecione o horário',
});

const requestedTokens = new Set(['requested', 'solicitada', 'request']);

const visitStatusToken = visit =>
  String(
    visit?.statusV3 ||
      visit?.status_v3 ||
      visit?.visitCardStatus ||
      visit?.visit_card_status ||
      visit?.status ||
      ''
  )
    .trim()
    .toLowerCase();

export const isRequestedVisit = visit =>
  requestedTokens.has(visitStatusToken(visit));

export const buildAgendaPopoverActions = ({
  visit = {},
  showConfirm = false,
  canCancel = true,
  canReschedule = true,
  isPool = false,
  includeMoreActions = true,
} = {}) => {
  const actions = [];

  if (showConfirm || isRequestedVisit(visit)) {
    actions.push({
      key: AGENDA_POPOVER_ACTIONS.CONFIRM,
      label: AGENDA_SATELLITE_TEXT.CONFIRM_VISIT,
      icon: 'i-lucide-circle-check',
      event: AGENDA_POPOVER_ACTIONS.CONFIRM,
    });
  }

  if (canCancel) {
    actions.push({
      key: isPool
        ? AGENDA_POPOVER_ACTIONS.CANCEL_VISITOR
        : AGENDA_POPOVER_ACTIONS.CANCEL,
      label: isPool
        ? AGENDA_SATELLITE_TEXT.CANCEL_VISITOR
        : AGENDA_SATELLITE_TEXT.CANCEL_VISIT,
      icon: 'i-lucide-calendar-x-2',
      tone: 'danger',
      event: AGENDA_POPOVER_ACTIONS.CANCEL,
    });

    if (isPool) {
      actions.push({
        key: AGENDA_POPOVER_ACTIONS.CANCEL_GROUP,
        label: AGENDA_SATELLITE_TEXT.CANCEL_VISIT,
        icon: 'i-lucide-users-round',
        tone: 'danger',
        event: AGENDA_POPOVER_ACTIONS.CANCEL_GROUP,
      });
    }
  }

  if (canReschedule) {
    actions.push({
      key: AGENDA_POPOVER_ACTIONS.RESCHEDULE,
      label: AGENDA_SATELLITE_TEXT.RESCHEDULE_VISIT,
      icon: 'i-lucide-calendar-clock',
      event: AGENDA_POPOVER_ACTIONS.RESCHEDULE,
    });
  }

  if (includeMoreActions) {
    actions.push({
      key: AGENDA_POPOVER_ACTIONS.MORE_ACTIONS,
      label: AGENDA_SATELLITE_TEXT.MORE_ACTIONS,
      icon: 'i-lucide-list-plus',
      event: AGENDA_POPOVER_ACTIONS.MORE_ACTIONS,
      separatorBefore: actions.length > 0,
    });
  }

  return actions;
};
